import { render, staticRenderFns } from "./DiscountPolicyForm.vue?vue&type=template&id=08486620&scoped=true"
import script from "./DiscountPolicyForm.vue?vue&type=script&lang=js"
export * from "./DiscountPolicyForm.vue?vue&type=script&lang=js"
import style0 from "./DiscountPolicyForm.vue?vue&type=style&index=0&id=08486620&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08486620",
  null
  
)

export default component.exports